import { StatusColorInputBase } from './types'

export const getColorStatus = (status: StatusColorInputBase) => {
  const colors = {
    error: 'red',
    success: 'green',
    default: 'gray'
  }

  return colors[`${status}`]
}
